import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'templatetag-multiselect-autocomplete',
  template:
    '<multi-autocomplete-list-item [selected]="selected" [item]="item" (changed)="toggle()"> <templatetag-template-list-item [item]="item" (clicked)="toggle()"></templatetag-template-list-item></multi-autocomplete-list-item>',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class MulitAutocompleteTemplateTagListItem {
  @Input() item: any;
  @Input() selected: any[];
  @Output() checkedChange: EventEmitter<any> = new EventEmitter<any>();
  toggle() {
    this.checkedChange.emit(this.item);
  }
}
